import LayoutBodyWrapper from "layouts/layout-parts/LayoutBodyWrapper";
import { Fragment, useState } from "react";
import { Outlet } from "react-router";
import DashboardSidebar from "./layout-v3/DashboardSidebar";
import DashboardHeader from "./layout-parts/DashboardHeader";

const LayoutStudent = ({ children }) => {
  const [sidebarCompact, setSidebarCompact] = useState(false);
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  const handleCompactToggle = () => setSidebarCompact(!sidebarCompact);

  const handleMobileDrawerToggle = () =>
    setShowMobileSideBar((state) => !state); // dashboard body wrapper custom style

  const customStyle = {
    width: `calc(100% - ${sidebarCompact ? "86px" : "310px"})`,
    marginLeft: sidebarCompact ? "86px" : "310px",
  };

  return (
    <Fragment>
      <DashboardSidebar
        sidebarCompact={sidebarCompact}
        showMobileSideBar={showMobileSideBar}
        setSidebarCompact={handleCompactToggle}
        setShowMobileSideBar={handleMobileDrawerToggle}
        participantMenu={true}
      />

      <LayoutBodyWrapper sx={customStyle}>
        <DashboardHeader
          setShowSideBar={handleCompactToggle}
          setShowMobileSideBar={handleMobileDrawerToggle}
        />

        {children || <Outlet />}
      </LayoutBodyWrapper>
    </Fragment>
  );

  // return (
  //   <Fragment>
  //     <LayoutBodyWrapper>
  //       <Stack direction="row" sx={{ backgroundColor: "#fff", padding: 2 }}>
  //         <Grid
  //           container
  //           alignItems="left"
  //           justifyContent="left"
  //           justifyItems="left"
  //           alignContent="center"
  //         >
  //           <img
  //             alt="company logo"
  //             width="200"
  //             src={getCompanyLogo(
  //               user?.user?.companyId,
  //               user?.user?.companyName
  //             )}
  //           ></img>
  //         </Grid>

  //         <Grid
  //           item
  //           container
  //           alignItems="right"
  //           justifyContent="right"
  //           justifyItems="right"
  //           alignContent="center"
  //         >
  //           <Grid item>
  //             <ProfilePopover />
  //           </Grid>
  //         </Grid>
  //       </Stack>
  //       {children || <Outlet />}
  //     </LayoutBodyWrapper>
  //   </Fragment>
  // );
};

export default LayoutStudent;
